let certificatesCache = null;
let certificatesPromise = null;

export function loadCertificates() {
  if (certificatesCache) {
    return Promise.resolve(certificatesCache);
  }

  if (!certificatesPromise) {
    certificatesPromise = fetch('/certificates.json')
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to load certificates: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        certificatesCache = data || {};
        return certificatesCache;
      })
      .catch((error) => {
        certificatesPromise = null;
        console.error(error);
        certificatesCache = {};
        return certificatesCache;
      });
  }

  return certificatesPromise;
}

export function getCertificateUrl(item, certificates = certificatesCache) {
  if (!item || !certificates) return null;

  const candidates = [item.article, item.articleSearch]
    .filter(Boolean)
    .map((value) => String(value).trim());

  for (const key of candidates) {
    if (certificates[key]) return certificates[key];
    const upper = key.toUpperCase();
    if (certificates[upper]) return certificates[upper];
  }

  return null;
}
